import type { Trend } from '@root/entities/trend'

export type MetricsTheme = 'bright' | 'dark'

export const METRICS_COLOR_MAP: Record<
  MetricsTheme,
  {
    [key in Trend.Trend | 'white']: string
  }
> = {
  bright: {
    up: 'var(--up-9)',
    down: 'var(--down-9)',
    neutral: 'var(--neutral-11)',
    white: '#fff',
  },
  dark: {
    up: 'var(--up-9)',
    down: 'var(--down-9)',
    neutral: 'var(--neutral-11)',
    white: 'var(--background-12)',
  },
}
